import Vue from 'vue'
import Router from 'vue-router'
import View from '@/components/common/view'
// import page from './page'

import Home from '../components/Home'
// 公司团体雇主责任险
import companyGroupEmployer from './companyGroupEmployer'
// 公司团体雇主责任险 国寿
import companyGroupEmployerGS from './companyGroupEmployerGS'
// 公司团体雇主责任险 云立方家装雇主责任险
import companyGroupEmployerYunLiFang from './companyGroupEmployerYunLiFang'
// 定制建工雇主责任险
import customizedEmployerLiability from './customizedEmployerLiability'
// 大地人资
import companyGroupEmployerDadi from './companyGroupEmployerDadi'
// 物流特三
import forklift from './forklift'

// 同线工人
import lineWork from './lineWork'

// 我的
import my from './my'

//app产品批量导入被保人
import appProduct from './appProduct'

// 实习生雇主责任险
import traineeEmployer from './traineeEmployer'

// 延保履约服务
import yanbao from './yanbao'

// 置换保
import zhihuanbao from './zhihuanbao'

// 货车雇主责任险
import truckEmployer from './truckEmployer'

// 金控保障计划
import jinkong from './jinkong'

// 创客工人
import makerWorker from './makerWorker'

// 创客保障计划-集团投保
import group from './group'

// 灵活用工雇主
import flexibleEmployer from './flexibleEmployer'

// 特种设备第三者责任险
import spcleqpt from './spcleqpt'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: Home,
            name: 'home'
        },
        // {
        // 	path: '/page',
        // 	component: View,
        // 	children: page
        // },
        {
            path: '/company-group-employer',
            component: View,
            children: companyGroupEmployer
        },
        {
            path: '/company-group-employergs',
            component: View,
            children: companyGroupEmployerGS
        },
        {
            path: '/company-group-employer-yunlifang/:projectKey?',
            component: View,
            children: companyGroupEmployerYunLiFang
        },
        {
            path: '/my',
            component: View,
            children: my
        },
        {
            path: '/app-product',
            component: View,
            children: appProduct
        },
        {
            path: '/trainee-employer',
            component: View,
            children: traineeEmployer
        },
        {
            path: '/yanbao',
            component: View,
            children: yanbao
        },
        {
            path: '/zhihuanbao',
            component: View,
            children: zhihuanbao
        },
        {
            path: '/truck-employer',
            component: View,
            children: truckEmployer
        },
        {
            path: '/jinkong',
            component: View,
            children: jinkong
        },
        {
            path: '/maker-worker',
            component: View,
            children: makerWorker
        },
        {
            path: '/group',
            component: View,
            children: group
        },
        {
            path: '/customized-employer-liability',
            component: View,
            children: customizedEmployerLiability
        },
        {
            path: '/companyGroupEmployerDadi',
            component: View,
            children: companyGroupEmployerDadi
        },
        {
            path: '/forklift',
            component: View,
            children: forklift
        },
        {
            path: '/lineWork',
            component: View,
            children: lineWork
        },
        {
            path: '/flexible-employer',
            component: View,
            children: flexibleEmployer
        },
        {
            path: '/spcleqpt',
            component: View,
            children: spcleqpt
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        // console.log(to)
        return { x: 0, y: 0 }
    }
})



// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/index.js